<template>
  <div
    v-if="!isUpdating"
    class="frontend-app"
  >
    <router-view />
  </div>
</template>

<script>
import { isEqual } from 'lodash-es';
import { Entry } from './types/Entry';
import { createApp } from './app';
import { isFrontendAppEmbedded } from './library/isFrontendAppEmbedded';
import { isSyncPropExist } from './library/isSyncPropExist';
import {
  SYNC_PROP_SELF_TENANT_UUID,
  SYNC_PROP_TENANT_UUID,
  SYNC_PROP_LANGUAGE,
  SYNC_PROP_BRANDING
} from './constants';

export default {
  name: 'FrontendAppComponent',
  props: {
    entry: {
      type: String,
      default: Entry.Wizard
    }
  },
  data() {
    return {
      isInitializing: false,
      isInitialized: false,
      isUpdating: false,
      unwatch: () => {}
    };
  },
  async mounted() {
    const app = createApp(
      this.$router,
      this.$store,
      this.$i18n,
      this.$analytics,
      isFrontendAppEmbedded() ? this.$el : undefined
    );

    this.unwatch = this.$watch(
      (vm) => ({
        selfTenantUuid: vm.$store.getters[`stateSync/${SYNC_PROP_SELF_TENANT_UUID}`],
        tenantUuid: vm.$store.getters[`stateSync/${SYNC_PROP_TENANT_UUID}`],
        language: vm.$store.getters[`stateSync/${SYNC_PROP_LANGUAGE}`],
        branding: vm.$store.getters[`stateSync/${SYNC_PROP_BRANDING}`]
      }),
      async (newSyncProps, oldSyncProps) => {
        if (!isEqual(newSyncProps, oldSyncProps) && Object.values(newSyncProps).every(isSyncPropExist)) {
          if (!this.isInitialized) {
            this.isInitializing = true;
            await app.initialize({
              ...newSyncProps,
              entry: this.entry
            });
            this.isInitializing = false;

            this.isInitialized = true;
          } else {
            this.isUpdating = true;
            await app.update(newSyncProps);
            this.isUpdating = false;
          }
        }
      },
      {
        immediate: true,
        deep: true
      }
    );
  },
  beforeUnmount() {
    this.unwatch();
  }
};
</script>

<style src="@/styles/index.scss" lang="scss" />
